export default "__VITE_ASSET__c463207c__"